module.exports = __webpack_public_path__ + "img/favicon.d5108276.png";